import { action } from 'easy-peasy';

import { IDocumentActions, IDocumentState } from 'types';

export const actions: IDocumentActions = {
  setDocumentsLoading: action<IDocumentState, boolean>((state, payload) => {
    state.isDocumentsLoading = payload;
  }),
};
